/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserSignatureDto } from '../../models/user-signature-dto';

export interface GetMySignature$Params {
}

export function getMySignature(http: HttpClient, rootUrl: string, params?: GetMySignature$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSignatureDto>> {
  const rb = new RequestBuilder(rootUrl, getMySignature.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserSignatureDto>;
    })
  );
}

getMySignature.PATH = '/users/me/signature';
